import "./App.scss";
import { Layout } from "antd";
import md5 from "js-md5";
import logo from "./assets/kuaifuwang.svg";
import Login from "./pages/login";
import React from "react";
import FindPassword from "./pages/find_password";
import CreateAccount from "./pages/create_account";
import { Route, Switch, Redirect, NavLink } from "react-router-dom";
import { useEffect } from "react";
import gongan from "./assets/gongan.png";

const { Header, Content } = Layout;

React.Component.prototype.$md5 = md5;
function App(props) {
  useEffect(() => {
    switch (props.history.location.pathname) {
      case "/create_account":
        document.title = "快服网_注册";
        break;
      case "/login":
        document.title = "快服网_登录";
        break;
      case "/find_password":
        document.title = "快服网_找回您的密码";
        break;
    }
  }, [props.history.location.pathname]);
  return (
    <div className="App">
      <Header className="loginHead">
        <div
          className="logoArea"
          onClick={() => {
            window.location.href =
              window.location.origin.indexOf("kuaifu.com") !== -1
                ? "https://www.kuaifu.com.cn/"
                : "https://shop.71baomu.com/index";
          }}
        >
          <img src={logo} alt="logo" />
        </div>
        <div className="operationArea">
          <NavLink to="login" activeClassName="activeRoute">
            登录
          </NavLink>

          <NavLink to="/create_account" activeClassName="activeRoute">
            创建您的账户
          </NavLink>

          <NavLink to="/find_password" activeClassName="activeRoute">
            找回您的密码
          </NavLink>
          <a
            href={
              window.location.origin.indexOf("kuaifu.com") !== -1
                ? "https://www.kuaifu.com.cn/"
                : "https://shop.71baomu.com/index"
            }
            activeClassName="activeRoute"
            style={{ marginRight: "0" }}
          >
            快服网首页
          </a>
        </div>
      </Header>
      <Content className="contentArea">
        <Switch>
          <Route
            path="/login"
            component={(props) => <Login {...props} />}
            exact
          ></Route>
          <Route
            path="/create_account"
            component={(props) => <CreateAccount {...props} />}
            exact
          ></Route>
          <Route
            path="/find_password"
            component={(props) => <FindPassword {...props} />}
            exact
          ></Route>
          <Redirect to="/login"></Redirect>
        </Switch>
      </Content>
      <div
        className="loginFooter"
        style={{
          background:
            props.history.location.pathname !== "/login" ? "#ffffff" : "",
        }}
      >
        <div className="loginFooterBr"></div>
        <div className="loginFooterTaext">
          <div>
            Copyright © 2005-{new Date().getFullYear()} 快服科技 版权所有
            全国统一受理热线：400-611-2183 合作邮箱：bd@53KF.com
            备案号：
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              className="beian"
              style={{ textDecoration: "underline" }}
            >
              浙ICP备19035559号
            </a>
          </div>
          <div className="gongan-div">
            <img src={gongan} class="" />
            <a class="gongan" href="https://beian.mps.gov.cn/#/query/webSearch?code=33071802889243" rel="noreferrer" target="_blank">浙公网安备33071802889243号</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
